import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import parse from 'html-react-parser';

import Roof from './Roof'
import logo from './mtsolarlogo.jpeg'
import './App.css'

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



export default function App() {
  const [value, setValue] = useState(0);
  const [roofs,setRoofs] = useState([])
  const [numrooffaces,setNumRoofFaces]=useState(0)
  const [optnumrooffaces, setOptNumRoofFaces] = useState([])



  useEffect(()=> {
    let numroofs = []
    if(optnumrooffaces.length === 0) {
      for(let ir=1; ir<=20; ir++)
        numroofs.push(<option key={`nr_opt_${ir}`}  value={ir}>{ir}</option>)
      setOptNumRoofFaces(numroofs)
    }
  },[optnumrooffaces, numrooffaces])

  const handleChange = (event, newValue) => {
    setValue(parseInt(newValue??0));
  };

  const handleSetRoofFaces = (e) => {
    setNumRoofFaces(e)
    const rf = parseInt(e)
    if( rf > roofs.length) {
      for(let i=roofs.length; i<rf; i++)
        setRoofs((curroof) => [...curroof, {index: i, arrays: [], rooftype: '', description: ''}])
    }

  }

  const updateRoof = (index,roofdata) => {

    for(const roof of roofs) {
      if(roof.index === roofdata.index )
        console.log('we would update new roofdata',roofdata)
      else
        console.log(`we would update with original roof, roof`)
    }

    setRoofs((curroofs)=> { const newroofdata = (curroofs??[]).map(roof => {
        if(roof.index === roofdata.index)
          return roofdata
        return (roof)
        })
        console.log(`in map update roof data `,newroofdata)
        return newroofdata
      }
    )
  }
const requireHookStope = (rooftype) => {
  switch(rooftype) {
    case "pantile":
    case "pantileclay":
    case "otherclay":
    case "slate":
      return true;
    default:
      return false
  }
}
const summary = () => {
  let data = []
  let roofrailtotal = []
  let roofarrrailtotal = []
  let iroof = 0;
  let railtot = 0;
  let totpanels = 0;
  let joinertot = 0;
  let hookstot = 0;
  let clamptots = 0;
  let endcapstot = 0;
  let hookstopstot = 0;
  for(const roof of roofs ) {
    roofrailtotal.push(0)
    let iarray = 0
    for(const array of roof.arrays) {
      let irow = 1
      let roofarraytotal = 0;
      for(const row of array.rows) {
        let rail = 0;
        if(row.orientation === 'portrait') {
          rail = parseInt(row.nopanels??0) * 2 * 1.1;
        }else{
          rail = parseInt(row.nopanels??0) * 2 * 2.05;
        }
        roofarrrailtotal.push([])
        roofarrrailtotal[iroof].push([])
        roofarrrailtotal[iroof][iarray]+=rail
        roofrailtotal[iroof]+=rail
          data.push({roof: iroof+1, roofdesc: roof.description, tiletype: roof.rooftype,  array: array.index, arraydesc: array.description, row: irow, rail, nopanels: parseInt(row.nopanels), orientation: row.orientation})
        irow++
      }
      iarray++
    }
  }
  console.log(roofrailtotal)
  console.log(roofrailtotal)
  console.log(data)
  return (
    <>
      <table >
        <thead>
          <tr>
            <th>Roof</th>
            <th>Array Desc</th>
            <th>Array</th>
            <th>Row</th>
            <th>Orientation</th>
            <th>Qty Panels</th>
            <th>Qty Rail (m)</th>
            <th>Qty Joiners</th>
            <th>Qty Hooks</th>
            <th>Mid/End Clamps</th>
            <th>End Caps</th>
            <th>Qty Matts</th>
          </tr>
        </thead>
        <tbody>

  {data.map((item,index) => {
    let roof = ''
    let arrdesc = ''
    let joiners = parseInt(((item.rail / 2)/4)+0.05)*2
    let hooks = parseInt(((((item.rail / 2)+0.5)-0.4)/1.2)+0.5)*2
    let clamps = (item.nopanels*2)+2
    let endcaps = 4
    let hookstops = hooks * 2
    if(index === 0 ) {
      railtot = parseInt(item.rail*10)/10
      totpanels = item.nopanels??0
      joinertot = joiners
      hookstot = hooks
      clamptots = clamps
      endcapstot = endcaps
      hookstopstot = hookstops;
    }else{
      railtot += parseInt(item.rail*10)/10
      totpanels += (item.nopanels??0)
      joinertot+=joiners
      hookstot+=hooks
      clamptots += clamps
      endcapstot += endcaps
      hookstopstot += hookstops;
    }
    if(item.array === 0 && item.row === 1) {

      roof = `${item.roofdesc}<br/>( ${item.tiletype} Tile)`
      arrdesc = `Array ${item.array+1} - ${item.arraydesc}`
    }

    if(item.row===1 )
      arrdesc = `Array ${item.array+1} - ${item.arraydesc}`
    return (
      <tr>
        <td >{parse(roof)}</td>
        <td >{parse(arrdesc) } </td>
        <td >{item.array+1}</td>
        <td >{item.row}</td>
        <td >{item.orientation}</td>
        <td >{item.nopanels}</td>
        <td >{parseInt(item.rail*10)/10} m</td>
        <td >{joiners}</td>
        <td >{hooks}</td>
        <td >{clamps}</td>
        <td >{endcaps}</td>
        <td >{requireHookStope(item.tiletype)?hookstops:'N/A'}</td>

      </tr>
    )
  })}
  <tr>
    <td colspan='5'>Totals</td>
    <td>{totpanels}</td>
    <td>{parseInt(railtot*10)/10}m</td>
    <td>{joinertot}</td>
    <td>{hookstot}</td>
    <td>{clamptots}</td>
    <td>{endcapstot}</td>
    <td></td>
  </tr>
  <tr><td colspan='12'>&nbsp;</td></tr>
  <tr><td colspan='12'>&nbsp;</td></tr>
  <tr>
    <td colspan='3'>Qty of 4M Lengths of Clenergy Rail:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{parseInt((railtot/4)+0.99)}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  <tr>
    <td colspan='3'>Total Qty of Joiners:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{joinertot}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  <tr>
    <td colspan='3'>Total Qty of Hooks:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{hookstot}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  <tr>
    <td colspan='3'>Total Qty of Mid/End Clamps:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{clamptots}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  <tr>
    <td colspan='3'>Total Qty of End Caps:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{endcapstot}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  <tr>
    <td colspan='3'>Total Hook Stops:</td>
    <td colspan='2' style={{textAlign: 'right'}} >{hookstopstot===0?'N/A':hookstopstot}</td>
    <td colspan='7'>&nbsp;</td>
  </tr>
  </tbody>
      </table>
      </>
  )
}

  return (
    <Box sx={{ width: '100%' }}>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab key='imgtab' label='___' component={()=> (<img src={logo} width="100" />)} />
          <Tab key='tab_0' label="Setup & Calcs" {...a11yProps(1)} />
          {(roofs??[]).map((item,index)=> {
            const label = `Roof ${index+1}`
            return (
              <Tab key={`tab_${index+2}`} label={label} {...a11yProps(index+2)} />
            )
          })}
        </Tabs>
      </Box>
      <CustomTabPanel value={parseInt(value)} index={1}>
        <h1>Roof Setup</h1>
        How Many Roof Faces have Solar Panels
        <select id='numrooffaces' style={{marginLeft: '10px' }} onChange={(e)=>handleSetRoofFaces(e.target.value) } value={numrooffaces} >
          <option key='nr_opt_0' value={0} >Please Select How Many Roof Faces will have Solar</option>
          {(optnumrooffaces??[]).map(item => {return item})}
        </select>
        {roofs.reduce((accumulator,current) => accumulator+=(current.arrays??[]).length,0) > 0 &&
          summary()
        }
      </CustomTabPanel>
        {
          (roofs??[]).map((item,index) => {
            return (
              <CustomTabPanel key={`ctp_${index+2}`} value={parseInt(value)} index={index+2}>
                <Roof key={`roof_key_${index}`} index={index} roofdata={item} onChange={updateRoof} />
              </CustomTabPanel>
            )
          })
        }
    </Box>
  );
}